export const CustomerListConstants = {
   PUBLISH:"Published",
   DRAFT:"Draft"
  }
    